const GlobalLoading = () => {
  return <div></div>;
};

export default GlobalLoading;
